import { notEmptyField } from 'shared/modules';

export default (val, text, obj) => {
  let errText = '';
  if (!val) {
    errText = notEmptyField(val, text);
  }
  if (obj && obj.password && !errText) {
    if (!/[0-9]/.test(val)) {
      errText = 'Пароль не содержит цифр';
    }
    if (/[А-Яа-я]/.test(val)) {
      errText = 'Разрешены только буквы, цифры и общие символы пунктуации';
    }
    if (!/[A-Za-z]/.test(val)) {
      errText = 'Пароль не содержит букв';
    }
    if (val.length < 8) {
      errText = 'Пароль содержит меньше восьми символов';
    }
    if (/\s/.test(val)) {
      errText = 'Пароль не должен содержать пробелов';
    }
  }
  if (obj.bool) {
    return !errText;
  }
  if (errText) {
    return errText;
  }
  return text;
};



// WEBPACK FOOTER //
// ./src/shared/modules/textErrField.js